Object.defineProperty(exports, "__esModule", { value: true });
exports.BenefitsInfo = exports.OutstaffingInfo = exports.SupportInfo = exports.ProtectionInfo = exports.ServicesInfo = exports.DevelopingInfo = exports.ProjectsInfo = exports.ReviewsInfo = exports.ClientsLogo = exports.access_token = exports.pageId = exports.appId = void 0;
exports.appId = '1329011377289870';
exports.pageId = '1476834779292911';
exports.access_token = 'EAAS4upMLuo4BANeSyT0U5KQ7627tdSZAdsAHT5B505CtTI4BmatQz34s0aG0YibQrjY12RfnZBlfGxoLa50r2mzJLGkbmZCS41Do9AxpSZCglzrXHHjxMhZC2AaSEUscf9b2w8Yi3PZAZAM0n7yOrozOBEiI6AARSZCYFQpbcNnaCwsaumxupe83';
exports.ClientsLogo = [
    '/images/clients/sberbank.png',
    '/images/clients/microsoft.png',
    '/images/clients/vtb.png',
    '/images/clients/mgts.png',
    '/images/clients/vsk.png',
    '/images/clients/sochi2014.png',
    '/images/clients/toyota.png',
    '/images/clients/lexus.png',
    '/images/clients/severstal.png',
    '/images/clients/gtnn.png',
    '/images/clients/pf-mgu.png',
    '/images/clients/nnobl.png',
    '/images/clients/cbrf.png',
    '/images/clients/sgm.png',
    '/images/clients/tnl.png',
    '/images/clients/mvideo.png',
    '/images/clients/alfabank.png',
    '/images/clients/x5retail.png',
    '/images/clients/pyatyorochka.png',
    '/images/clients/perekryostok.png'
];
exports.ReviewsInfo = [
    {
        path: '/images/reviews/client2.png',
        description: 'reviews.client2.description',
        person: 'reviews.client2.person',
        position: 'reviews.client2.position'
    },
    {
        path: '/images/reviews/client1.png',
        description: 'reviews.client1.description',
        person: 'reviews.client1.person',
        position: 'reviews.client1.position'
    }
];
exports.ProjectsInfo = [
    {
        prevPath: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        nextPath: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        path: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        title: 'ШерЛок для Microsoft Office и LibreOffice, ожидается Р7-Офис',
        description: 'Демо по распознаванию и защите конфиденциальных документов с использованием нейросети.',
        info: ''
    },
    {
        prevPath: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        nextPath: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        path: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        title: 'ШерЛок для Microsoft Office и LibreOffice, ожидается Р7-Офис',
        description: 'Демо по распознаванию и защите конфиденциальных документов с использованием нейросети.',
        info: ''
    },
    {
        prevPath: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        nextPath: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        path: 'https://sharelockru.azurewebsites.net/sharelock/sharelock-video.mp4',
        title: 'ШерЛок для Microsoft Office и LibreOffice, ожидается Р7-Офис',
        description: 'Демо по распознаванию и защите конфиденциальных документов с использованием нейросети.',
        info: ''
    },
];
exports.DevelopingInfo = [
    {
        path: '/images/features/fullcycle.png',
        title: 'developing-info.fullcycle.title',
        lines: [
            'developing-info.fullcycle.lines.first',
            'developing-info.fullcycle.lines.second',
            'developing-info.fullcycle.lines.third'
        ]
    },
    {
        path: '/images/features/tech.png',
        title: 'developing-info.tech.title',
        lines: [
            'developing-info.tech.lines.first',
            'developing-info.tech.lines.second',
            'developing-info.tech.lines.third'
        ]
    },
    {
        path: '/images/features/effective.png',
        title: 'developing-info.effective.title',
        lines: [
            'developing-info.effective.lines.first',
            'developing-info.effective.lines.second',
            'developing-info.effective.lines.third',
            'developing-info.effective.lines.fourth'
        ]
    }
];
exports.ServicesInfo = [
    {
        path: '/images/features/development.png',
        title: 'services.development.title',
        lines: [
            'services.development.first',
            'services.development.second',
            'services.development.third'
        ]
    },
    {
        path: '/images/features/migration.png',
        title: 'services.migration.title',
        lines: [
            'services.migration.first',
            'services.migration.second',
            'services.migration.third'
        ]
    },
    {
        path: '/images/features/cloud.png',
        title: 'services.cloud.title',
        lines: [
            'services.cloud.first',
            'services.cloud.second',
            'services.cloud.third'
        ]
    },
    {
        path: '/images/features/point.png',
        title: 'services.point.title',
        lines: [
            'services.point.first',
            'services.point.second',
            'services.point.third',
            'services.point.fourth'
        ]
    }
];
exports.ProtectionInfo = [
    {
        path: '/images/features/fullcycle.png',
        title: 'protect.fullcycle.title',
        lines: [
            'protect.fullcycle.first',
            'protect.fullcycle.second'
        ]
    },
    {
        path: '/images/features/tech.png',
        title: 'protect.tech.title',
        lines: [
            'protect.tech.first'
        ]
    },
    {
        path: '/images/features/effective.png',
        title: 'protect.effective.title',
        lines: [
            'protect.effective.first'
        ]
    }
];
exports.SupportInfo = [
    {
        path: '/images/features/24x7.png',
        title: 'support.alltime.title',
        lines: [
            'support.alltime.first',
            'support.alltime.second',
            'support.alltime.third',
            'support.alltime.fourth'
        ]
    },
    {
        path: '/images/features/updates.png',
        title: 'support.updates.title',
        lines: [
            'support.updates.first',
            'support.updates.second',
            'support.updates.third'
        ]
    },
    {
        path: '/images/features/cost.png',
        title: 'support.cost.title',
        lines: [
            'support.cost.first',
            'support.cost.second'
        ]
    },
    {
        path: '/images/features/aggreement.png',
        title: 'support.aggreement.title',
        lines: [
            'support.aggreement.first',
            'support.aggreement.second',
            'support.aggreement.third'
        ]
    }
];
exports.OutstaffingInfo = [
    {
        title: 'outstaffing.title1'
    },
    {
        title: 'outstaffing.title2'
    },
    {
        title: 'outstaffing.title3'
    }
];
exports.BenefitsInfo = [
    {
        path: '/images/features/tools.png',
        title: 'benefits.tools.title',
        lines: [
            'benefits.tools.first'
        ]
    },
    {
        path: '/images/features/wide.png',
        title: 'benefits.wide.title',
        lines: [
            'benefits.wide.first'
        ]
    },
    {
        path: '/images/features/areas.png',
        title: 'benefits.areas.title',
        lines: [
            'benefits.areas.first'
        ]
    },
    {
        path: '/images/features/team.png',
        title: 'benefits.team.title',
        lines: [
            'benefits.team.first'
        ]
    },
    {
        path: '/images/features/mspartner.png',
        title: 'benefits.mspartner.title',
        lines: [
            'benefits.mspartner.first'
        ]
    },
    {
        path: '/images/features/yapartner.png',
        title: 'benefits.yapartner.title',
        lines: [
            'benefits.yapartner.first'
        ]
    }
];
//# sourceMappingURL=common.js.map